/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unranked_Reason_No_ResultsInputs */



/**
* | output |
* | --- |
* | "no recorded results" |
*
* @param {Tournament_Unranked_Reason_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unranked_reason_no_results = /** @type {((inputs?: Tournament_Unranked_Reason_No_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unranked_Reason_No_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("aucun résultat enregistré")
	if (locale === "es") return /** @type {LocalizedString} */ ("sin resultados registrados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("sem resultados registrados")
	if (locale === "it") return /** @type {LocalizedString} */ ("nessun risultato registrato")
	return /** @type {LocalizedString} */ ("no recorded results")
});